
  const replaceUnderscoresWithSpaces = (input: string) => {
    return input.replace(/_/g, ' ');
  }
  export default replaceUnderscoresWithSpaces;